var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BAINA_API, BAINA_API_KEY } from './interface';
import { REPORT_QUERY } from './lib/utils';
var DEFAULT_TRY_TIMES = 3;
var DEFAULT_AUTO_REPORT_COUNT = 10;
var Noop = function () {
    /* Noop */
};
var defaultReportUrl = "" + BAINA_API.likee + REPORT_QUERY.default;
var helloReportUrl = "" + BAINA_API.hello + REPORT_QUERY.hello;
var globalConfig = {
    reportUrl: defaultReportUrl,
    logTryTimes: DEFAULT_TRY_TIMES,
    autoReportCount: DEFAULT_AUTO_REPORT_COUNT,
    hooks: {
        nativeapi: true,
        xhr: true,
        history: true,
        fetch: true,
        error: true,
        unhandledrejection: true,
        console: false
    },
    errorHandler: Noop,
    succHandler: Noop,
    requestDisableFilter: Noop,
    requestidEnableFilter: Noop,
    responseSaveFilter: Noop,
    stop: false,
    isCN: false,
    isDisableRequestid: false
};
function validOrBackup(param, type, backup) {
    return typeof param === type ? param : backup;
}
function validGlobalReportConfig(globalConfig) {
    if (typeof globalConfig !== 'object') {
        console.warn('[bigo-logger]请传入初始化 globalConfig 配置');
        return {};
    }
    var source = globalConfig.source;
    if (!/\w-\w/.test(source)) {
        console.warn('[bigo-logger]source 请按照[业务线]-[环境]格式传入，如source: bigolive-prod');
    }
    return globalConfig;
}
export default {
    set: function (configOb) {
        /**
         * 设置reportUrl
         */
        // 国内的话使用hello数据库
        if (configOb.isCN && !configOb.reportUrl) {
            configOb.reportUrl = helloReportUrl;
        }
        else if (
        // 直接设置app
        configOb.app &&
            configOb.app in BAINA_API) {
            if (configOb.app === BAINA_API_KEY.hello) {
                configOb.reportUrl = helloReportUrl;
                configOb.isCN = true;
            }
            else {
                configOb.reportUrl = "" + BAINA_API[configOb.app] + REPORT_QUERY.default;
            }
        }
        else if (
        // 根据source变更reportUrl
        configOb.globalReportConfig &&
            configOb.globalReportConfig.source) {
            for (var _i = 0, _a = Object.entries(BAINA_API); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                if (configOb.globalReportConfig.source.match(key)) {
                    if (key === BAINA_API_KEY.hello) {
                        configOb.reportUrl = helloReportUrl;
                        configOb.isCN = true;
                    }
                    else {
                        configOb.reportUrl = "" + value + REPORT_QUERY.default;
                    }
                    break;
                }
            }
        }
        globalConfig = {
            incrementalReport: validOrBackup(configOb.incrementalReport, 'boolean', true),
            // publicKey: validOrBackup(configOb.publicKey, 'string', undefined),
            logTryTimes: validOrBackup(configOb.logTryTimes, 'number', DEFAULT_TRY_TIMES),
            autoReportCount: validOrBackup(configOb.logTryTimes, 'number', DEFAULT_AUTO_REPORT_COUNT),
            reportUrl: validOrBackup(configOb.reportUrl, 'string', defaultReportUrl),
            dbName: validOrBackup(configOb.dbName, 'string', undefined),
            hooks: typeof globalConfig.hooks === 'object'
                ? __assign(__assign({}, globalConfig.hooks), configOb.hooks) : globalConfig.hooks,
            globalReportConfig: validGlobalReportConfig(configOb.globalReportConfig),
            errorHandler: validOrBackup(configOb.errorHandler, 'function', Noop),
            succHandler: validOrBackup(configOb.succHandler, 'function', Noop),
            requestDisableFilter: validOrBackup(configOb.requestDisableFilter, 'function', Noop),
            requestidEnableFilter: validOrBackup(configOb.requestidEnableFilter, 'function', Noop),
            responseSaveFilter: validOrBackup(configOb.responseSaveFilter, 'function', Noop),
            stop: validOrBackup(configOb.stop, 'boolean', false),
            isCN: validOrBackup(configOb.isCN, 'boolean', false),
            _devSend: validOrBackup(configOb._devSend, 'boolean', false),
            isDisableRequestid: validOrBackup(configOb.isDisableRequestid, 'boolean', false)
        };
    },
    setKey: function (key, value) {
        // @ts-ignore
        globalConfig[key] = value;
    },
    get: function (propertyKey) {
        return globalConfig[propertyKey];
    }
};
